export function getColorFromString(str: string): string {
    // Use better algorithm (FNV-1a variant)
    const fnv1a = (input: string, seed: number): number => {
        let hash = seed;
        for (let i = 0; i < input.length; i++) {
            hash ^= input.charCodeAt(i);
            hash = Math.imul(hash, 16777619);
            hash = hash >>> 0; // Force to 32-bit unsigned
        }
        return hash;
    };

    // Generate three independent hashes
    const rHash = fnv1a(str + 'R', 0x811c9dc5);
    const gHash = fnv1a(str + 'G', 0x811c9dc5);
    const bHash = fnv1a(str + 'B', 0x811c9dc5);

    // Create pastel RGB values (160-240 range for nice backgrounds)
    const r = 160 + (rHash % 81); // 160-240
    const g = 160 + (gHash % 81);
    const b = 160 + (bHash % 81);

    // Ensure enough brightness variation between channels
    // This creates more distinct and vibrant colors
    return `rgb(${r}, ${g}, ${b})`;
}